import { Link, useLocation } from "react-router-dom";
import { MapPin } from "lucide-react";
import { useApp } from "@/context/AppContext";

export function StickyAreaCta() {
  const { t, emergency } = useApp();
  const { pathname } = useLocation();
  const storm = emergency.auto && emergency.link === "/storm";
  if (pathname.startsWith("/local") || pathname.startsWith("/my-plan") || pathname.startsWith("/storm")) return null;
  return (
    <div data-print-hide className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
      <Link to={storm ? "/storm#check" : "/local"} data-testid="sticky-area-cta"
        className="flex w-full items-center justify-center gap-2 rounded-full bg-unionblue px-5 py-3 text-sm font-bold text-white shadow-md active:scale-[0.98] transition-transform">
        <MapPin className="h-4 w-4" /> {storm ? "Check my area for the storm" : t("cta.area")}
      </Link>
    </div>
  );
}
